document.addEventListener('DOMContentLoaded', function() {
    // Go one page up in FAQ by the back button
    var subcategoryButton = document.getElementById('subcategoryButton');
    if (subcategoryButton !== null) {
        subcategoryButton.addEventListener('click', function () {
            var previousURL = document.getElementById('previousURL').dataset.url;
            window.location.href = previousURL;
        });
    }

    // Make the icons and the question text clickable
    var questions = document.querySelectorAll('.faq-question');
    var icons = document.querySelectorAll('.fa-plus-square');

    questions.forEach(function(question) {
        question.addEventListener('click', function(event) {
            event.preventDefault();
            var answer = this.nextElementSibling;
            answer.style.display = answer.style.display === 'none' ? 'block' : 'none';

            var icon = this.previousElementSibling;
            icon.classList.toggle('fa-plus-square');
            icon.classList.toggle('fa-minus-square');
        });
    });

    icons.forEach(function(icon) {
        icon.addEventListener('click', function(event) {
            event.preventDefault();
            var answer = this.nextElementSibling.nextElementSibling;
            answer.style.display = answer.style.display === 'none' ? 'block' : 'none';

            this.classList.toggle('fa-plus-square');
            this.classList.toggle('fa-minus-square');
        });
    });
});
